import { screen, PScreenSize } from './device'
import { toast } from './toasts'
import rules from './validation'
import { Debounce } from './Debounce'
import { usePlatform } from './platform'
import { DeviceType, PlatformName } from './platform/types'
import { useFormat } from './format'
import { useColor } from './color'
import { useSpace } from './space'
import { useScrollIntoView } from './scrollIntoView'
import { validateFilesSize } from './file'

const usePrevioDS = () => {
  return {
    screen,
    toast,
    rules,
    debounce: Debounce,
    usePlatform,
    useFormat,
    useColor,
    useSpace,
    useScrollIntoView,
    validateFilesSize,
  }
}

export { usePrevioDS, toast, usePlatform, useFormat, validateFilesSize }
export { PScreenSize, PlatformName, DeviceType }
export * from './phone'
